import {
  Agreement,
  Money,
  Query,
  RdcOptionsResult,
  RdcOptionsSuccess,
  Typenames,
} from '@varo/graphql-schema-types';
import FetchRDCOptions from 'services/graphql/queries/FetchRDCOptions';
import { Maybe } from 'shared/utils/types';
import { CombinedError, RequestPolicy, useQuery } from 'urql';

interface RDCConfiguration {
  rdcOptions?: RdcOptionsResult;
  agreement?: Maybe<Agreement>;
  maxDeposit?: Maybe<Money>;
  error?: CombinedError;
  rdcAvailable: boolean;
  fetching: boolean;
  stale: boolean;
  refetch: () => void;
}

const useRDCOptions = (
  requestPolicy: RequestPolicy = 'cache-first',
): RDCConfiguration => {
  const [response, refetch] = useQuery<Query>({
    query: FetchRDCOptions,
    requestPolicy,
  });

  const { data, fetching, stale, error } = response;
  let rdcAvailable = false;
  let agreement: Maybe<Agreement> = null;
  let maxDeposit: Maybe<Money> = null;

  if (data?.rdcOptions?.__typename === Typenames.RdcOptionsSuccess && !error) {
    rdcAvailable = true;
    agreement = (data?.rdcOptions as RdcOptionsSuccess).agreement;
    maxDeposit = (data?.rdcOptions as RdcOptionsSuccess).maxDeposit;
  }

  return {
    rdcAvailable,
    rdcOptions: data?.rdcOptions,
    agreement,
    maxDeposit,
    fetching,
    error,
    stale,
    refetch,
  };
};

export default useRDCOptions;
